import CERRO_TUSA from "./location";

function CerroStamp({ bColor = "var(--c-ink)", baseColor = "#ddd0b0", bSize = 1.5 }) {
  return (
    <div className="ite__stamp" aria-label="Cerro Tusa, Colombia retreat location" style={{ background: baseColor }}>
      <div className="ite__stamp-inner" style={{ borderColor: bColor, borderWidth: bSize }}>
        <div className="ite__stamp-top">
          <span className="ite__stamp-place">CERRO TUSA</span>
          <span className="ite__stamp-country">COLOMBIA</span>
        </div>
        {/* Mini mountain SVG */}
        <div className="wfe__stamp-row">
          <span className="wfe__stamp-label">COORDINATES</span>
        </div>
        <div className="wfe__stamp-coords">{CERRO_TUSA.display}</div>
        <div className="wfe__stamp-divider" aria-hidden="true" />
        <div className="wfe__stamp-meta d-block">
          <span>ELEV. 1,850 M</span>
          <div>RETREAT 212</div>
        </div>

        <img src="./assets/mountainsForst.png" className="mountainesIco" alt="" />
      </div>
    </div>
  );
}

export default CerroStamp;
